export default {
    token: {
        screenMDMax: 999,
        screenLG: 1000,
        screenLGMin: 1000
    },
};